import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

// Danh sách các banner với ảnh và nội dung khác nhau
const banners = [
    {
        image: 'https://data.linklearn.vn/baner.png',
        title: 'Chia sẻ kiến thức của bạn',
        description: 'Tạo và chia sẻ học liệu của bạn với hàng triệu học viên trên LinkLearn'
    },
    {
        image: 'https://data.linklearn.vn/baner2.png',
        title: 'Trao kiến thức, nhận về yêu thương',
        description: 'Mỗi kiến thức bạn chia sẻ là một nấc thang để mở ra cánh cửa cho người khác' 
    },
    {
        image: 'https://data.linklearn.vn/baner3.png',
        title: 'Lưu trữ và chia sẻ dễ dàng',
        description: 'Lưu trữ file PDF, Video, Quiz và nhiều hơn nữa, tất cả tại một nơi'
    }
];

export default function Banner() {
    const [currentBanner, setCurrentBanner] = useState(0);

    useEffect(() => {
        // Thay đổi banner sau mỗi 7 giây
        const interval = setInterval(() => {
            setCurrentBanner((prev) => (prev + 1) % banners.length);
        }, 7000); // 7 giây

        return () => clearInterval(interval);
    }, []);

    const banner = banners[currentBanner];

    return (
        <div className="banner-container mb-4 px-3">
            <div className="position-relative banner-wrapper">
                {/* Background Image với fade transition */}
                <img 
                    key={currentBanner}
                    src={banner.image}
                    alt="Banner học liệu"
                    className="w-100 banner-image banner-fade"
                />

                {/* Gradient Overlay - Mờ bên trái */}
                <div className="banner-overlay-gradient" />

                {/* Text Content với fade transition */}
                <div className="banner-content" key={`content-${currentBanner}`}>
                    <h5 className="text-white fw-bold mb-3 banner-title banner-text-fade">
                        {banner.title}
                    </h5>
                    <p className="text-white mb-3 banner-description banner-text-fade">
                        {banner.description}
                    </p>
                    <div>
                        <Link 
                            to="/manageUser" 
                            className="banner-btn-gradient"
                        >
                            <svg className="banner-btn-icon" width="20" height="20" viewBox="0 0 24 24" 
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 4L12 20M12 4L8 8M12 4L16 8" stroke="currentColor" 
                                strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Chia sẻ học liệu của bạn
                        </Link>
                    </div>
                </div>

                {/* Indicator dots */}
                <div className="banner-indicators">
                    {banners.map((_, index) => (
                        <button
                            key={index}
                            className={`banner-dot ${index === currentBanner ? 'active' : ''}`}
                            onClick={() => setCurrentBanner(index)}
                            aria-label={`Banner ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}
